import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { WeightToleranceType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

const WeightToleranceTypeSelect = ({ value, onChange }: Omit<SelectProps<WeightToleranceType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(WeightToleranceType)}
			getOptionLabel={option => intl.formatMessage({ id: `WEIGHT_TOLERANCE_TYPE_${option}` })}
			value={value}
			onChange={onChange}
			disableSearch />
	);
};

export default WeightToleranceTypeSelect;
